<template>
  <a-form-item name="action" label="Selecciona la siguiente acción a realizar" required>
    <!-- SendEmail = 3, SendWhatsapp = 4, SendSms = 5, AddTimeInterval = 6, -->
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      :value="value"
      @update:value="emit('update:value', $event)"
      :disabled="disabled || (!isMultichannel && value == SequenceNodeAction.MakeAutomaticCall)"
    >
      <!--v-if="showAction(key)"-->
      <a-select-option :value="SequenceNodeAction.Finish">
        {{ ActionNameByType[SequenceNodeAction.Finish] }}
      </a-select-option>
      <a-select-option :value="SequenceNodeAction.MakeAutomaticCall">
        {{ ActionNameByType[SequenceNodeAction.MakeAutomaticCall] }}
      </a-select-option>
      <a-select-option :value="SequenceNodeAction.SendEmail" :disabled="validateIdentifiers(SequenceNodeType.Email)">
        {{ ActionNameByType[SequenceNodeAction.SendEmail] }}
      </a-select-option>
      <a-select-option :value="SequenceNodeAction.SendWhatsapp" :disabled="validateIdentifiers(SequenceNodeType.Whatsapp)">
        {{ ActionNameByType[SequenceNodeAction.SendWhatsapp] }}
      </a-select-option>
      <a-select-option :value="SequenceNodeAction.SendSms" :disabled="validateIdentifiers(SequenceNodeType.Sms)">
        {{ ActionNameByType[SequenceNodeAction.SendSms] }}
      </a-select-option>
      <a-select-option :value="SequenceNodeAction.AddTimeInterval">
        {{ ActionNameByType[SequenceNodeAction.AddTimeInterval] }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script setup lang="ts">
import { Sequence, SequenceNodeType, SequenceNodeAction } from "@/@types/flows/sequences";
import { ActionNameByType } from "@/app/flows/sequences/utils/texts";
import { ref, onMounted } from "vue";
import { ChannelType } from "@/app/shared/utils/enums";

const props = withDefaults(
  defineProps<{
    value: SequenceNodeAction;
    disabled: boolean;
    isMultichannel: boolean;
    sequence: Sequence;
  }>(),
  {
    isMultichannel: true,
  }
);

const emit = defineEmits<{ "update:value": [newValue: SequenceNodeAction] }>();

const searchIdentifier = (channelType: number) => {
  const itemIndex = props.sequence.channels_customers.findIndex((el) => (el.channel?.id == channelType));
  return itemIndex > -1;
};

const validateIdentifiers = (nodeOption: any) => {
  if (nodeOption == SequenceNodeType.TimeInterval || nodeOption == SequenceNodeType.AutomaticCall)
    return false;
  else {
    let channelType: number = 0;
    switch (nodeOption) {
      case SequenceNodeType.Email:
        channelType = ChannelType.Email;
        break;
      case SequenceNodeType.Whatsapp:
        channelType = ChannelType.Whatsapp;
        break;
      case SequenceNodeType.Sms:
        channelType = ChannelType.Sms;
        break;
    }
    return !searchIdentifier(channelType);
  }
}

/*const showAction = (key: number) => {

  return true;
  console.log(key, '---key');
  console.log(SequenceNodeAction.Finish, '---SequenceNodeAction.Finish');
  if (props.isMultichannel) return true;
  else if (key == SequenceNodeAction.Finish || key == SequenceNodeAction.MakeAutomaticCall)
    return true;

  return false;
};*/

const actions = ref();

onMounted(() => {
  actions.value = SequenceNodeAction;
});
</script>

<style scoped lang="sass"></style>
